<template>
  <div class="box6-container">
    <div class="title">流量统计</div>
    <div class="content">
      <div id="flowChart" :style="{width: '100%', height: '100%'}"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Box6",
  props: {
    itemData: {
      type: Array,
      required: true, // 默认值是false
      default: function () {
        return [
          {
            timestamp: '00:00 00',
            usually: 0,
            edge: 0
          }
        ];
      },
    },
  },
  data() {
    return {
      flowData: {
        grid: {
          top: '20%',
          left: '10%',
          right: '2%',
          bottom: '15%'
        },
        legend: {
          orient: 'horizontal',
          x: 'right',
          y: '10',
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            color: '#fff',
            fontSize: 10,
          }
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
              lineStyle: {
                  color: '#aeef00'// 移上去线的颜色
              }
            }
        },
        xAxis: [{
            type: 'category',
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: '#0a4746'
              }
            },
            axisLabel: {
              textStyle: {
                color: '#6083b3',
                fontSize: 10
              }
            },
            data: []
        }],
        yAxis: [{
            name:'流量(B/s)',
            type: 'value',
            nameLocation: "end",
            nameTextStyle: {
              fontSize: 10,//正常是不用添加
              color: '#6083b3'
            },
            splitLine: {// 网格线{show: true}
              lineStyle: {
                type: 'dotted',
                color: '#0a4746', // 左边线的颜色
                width: '1'// 坐标线的宽度
              }
            },
            axisLine: {
              lineStyle: {
                color: '#0a4746'
              }
            },
            axisLabel: {
              textStyle: {
                color: '#6083b3'
              }
            }
        }],
        series: [{
          name: '边缘计算网关',
          type: 'line',
          smooth: true,
          symbol: 'circle',
          symbolSize: 5, // 鼠标移上圆点大小
          showSymbol: false,
          lineStyle: {
            normal: {
              width: 2
            }
          },
          areaStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(79, 73, 255, 0.3)'
              }, {
                  offset: 0.8,
                  color: 'rgba(170, 244, 135, 0)'
              }], false),
              shadowColor: 'rgba(0, 0, 0, 0.1)',
              shadowBlur: 10
            }
          },
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                  offset: 0,
                  color: 'rgba(79, 73, 255, 1)'
              }, {
                  offset: 1,
                  color: 'rgba(110,141,255,1)'
              }])
            }
          },
          data: []
        },
        {
          name: '普通网关',
          type: 'line',
          smooth: true,
          symbol: 'circle',
          symbolSize: 5, // 鼠标移上圆点大小
          showSymbol: false,
          lineStyle: {
            normal: {
              width: 2
            }
          },
          areaStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(170, 244, 135, 0.3)'
              }, {
                  offset: 0.8,
                  color: 'rgba(170, 244, 135, 0)'
              }], false),
              shadowColor: 'rgba(0, 0, 0, 0.1)',
              shadowBlur: 10
            }
          },
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                  offset: 0,
                  color: 'rgba(106, 223, 232, 1)'
              }, {
                  offset: 1,
                  color: 'rgba(63, 228, 166, 1)'
              }])
            }
          },
          data: []
        }]

      }
    }
  },
  watch: {
    itemData: {
      handler(newVal, oldVal) {
        if(oldVal){
          if(newVal[newVal.length-1].timestamp!=oldVal[oldVal.length-1].timestamp){
            this.drawChart()
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    drawChart () {
      const xAxisData = []
      const seriesData0 = []
      const seriesData1 = []
      for ( let i =0; i<this.itemData.length; i++ ){
        xAxisData[i] = this.itemData[i].timestamp
        seriesData0[i] = this.itemData[i].edge
        seriesData1[i] = this.itemData[i].usually
      }
      this.flowData.xAxis[0].data = xAxisData
      this.flowData.series[0].data = seriesData0
      this.flowData.series[1].data = seriesData1
      var flowChart = this.$echarts.init(document.getElementById('flowChart'))
      // 绘制图表
      flowChart.setOption(this.flowData)
    }
  },
  mounted () {
    this.drawChart()
  }
};
</script>
<style lang='less'>
.box6-container {
  width: 100%;
  height: 100%;
  position: relative;
  background: #06113c;
  padding:15px 5px 5px 5px;
  box-sizing: border-box;
  .title {
    font-size: 18px;
    line-height: 35px;
    font-weight: normal;
    color: #fff;
    display: block;
    width: 100%;
    height:35px;
    text-align: center;
    background: url(../../assets/images/title_bg.png) center top no-repeat;
    background-size: auto 100%;
  }
  .content {
    position: absolute;
    top: 40px;
    left: 10px;
    right: 10px;
    bottom: 0;
    padding:10px;
    // background: #1e1e1e;
    .scroll_box{
      width:100%;
      height:100%;
      font-size:12px;
      color:#fff;
      line-height: 1.4;
      font-family: Microsoft yahei;
      em,span,h1{
        font-style: normal;
      }
      p{
        margin:12px 0 0;
      }
      span{
        margin-left:10px;
      }
      .block_bg{
        background: #0dbc79;
        display: inline-block;
        padding:1px 5px;
        color:#000;
        margin-right: 10px;
      }
      .green{
        color:#0dbc79
      }
      .green_bg{
        background:#0dbc79
      }
      .red{
        color:#cd3131
      }
      .red_bg{
        background:#cd3131
      }
      .blue{
        color:#2472c8
      }
      .blue_bg{
        background:#2472c8
      }
      .grap{
        color:#919191
      }
    }
  }
}

.el-scrollbar__wrap{
  overflow-x: hidden !important;
}
.is-horizontal{
  display: none;
}
// /deep/ .el-scrollbar__wrap {
// overflow-x: hidden;
// }
</style>
